<template>
	<div>
		<o-section>
			<o-alert
				color="info"
				center>
				Sélectionner une date de fin de mission
			</o-alert>

			<o-datepicker
				v-model="setup.missionEndDate"
				label="Date de fin"
				required
				:min-date="new Date(timeTicketWeek.from)"
				:max-date="new Date(timeTicketWeek.to)"/>
		</o-section>

		<o-section align="right">
			<o-button
				color="danger"
				outline
				@click="setup._modal?.close()">
				Annuler
			</o-button>
			<o-button
				color="success"
				@click="setup.validateMissionEndAsync()">
				Valider
			</o-button>
		</o-section>
	</div>
</template>

<script setup lang="ts">
import TimeTicketMissionEndModalSetupService from '@/setup/time-ticket/TimeTicketMissionEndModalSetupService';
import { inject } from 'vue';
const _modal = inject<OrionModal>('_modal');
const props = defineProps(TimeTicketMissionEndModalSetupService.props);
const setup = new TimeTicketMissionEndModalSetupService(props, _modal);
</script>
